// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3oQre","tab":"ProcedureTabs_tab__sxvf3"};